<template>
  <div v-if="data">
    <page-header :header="data.name" />
    <edit-form
      v-if="data && $login.can('packages.update')"
      ref="edit"
      v-model="data"
      @loading="setLoading"
      @save-success="saveSuccess"
    />
  </div>
</template>

<script>
import axios from '@/axios'
import EditForm from './Form'
import {successNotification} from '@/notifications'

export default {
  components: {
    EditForm,
  },

  metaInfo () {
    return {
      title: this.data ? this.data.name : 'View Package',
    }
  },

  data () {
    return {
      loading: false,
      data: null,
    }
  },

  created () {
    this.getPackage()
  },

  methods: {
    async getPackage () {
      const {packageId} = this.$route.params
      const {data} = await axios.get(`/roles/${packageId}`)
      this.data = data.data
    },

    setLoading (loading) {
      this.loading = loading
    },

    updatePermissions ({permissions}) {
      this.data.permisions = permissions
    },

    saveSuccess () {
      this.$notify(successNotification('Updated package!'))
      this.loading = false
    },

    save () {
      this.$refs.edit.save()
    },
  },
}
</script>
